var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        ref: "reviewModal",
        staticClass: "modal fade",
        attrs: {
          id: "reviewModal",
          tabindex: "-1",
          "aria-labelledby": "reviewModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c(
            "div",
            {
              staticClass:
                "modal-content border-0 rounded-4 overflow-hidden shadow-lg",
            },
            [
              _c("button", {
                staticClass: "btn-close position-absolute top-0 end-0 m-3",
                staticStyle: { "z-index": "10", opacity: "0.4" },
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body px-4 pt-5 pb-4" }, [
                _vm.finished
                  ? _c("div", { staticClass: "text-center py-3" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("h5", { staticClass: "fw-bold mb-1" }, [
                        _vm._v(_vm._s(_vm._f("translate")("Thank you!"))),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-muted small mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Your review has been submitted."
                            )
                          )
                        ),
                      ]),
                    ])
                  : _c("div", [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("h5", { staticClass: "text-center fw-bold mb-1" }, [
                        _vm._v(_vm._s(_vm._f("translate")("Leave a review"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "text-center text-muted small mb-4" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("translate")(
                                "Would you recommend this product to others?"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center gap-3 mb-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "text-center flex-grow-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn rounded-3 px-3 py-2 w-100",
                                  class:
                                    _vm.rating === 10
                                      ? "btn-dark"
                                      : "btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.rating = 10
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "far fa-smile fa-2x d-block mb-1",
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "small" }, [
                                    _vm._v(_vm._s(_vm._f("translate")("Yes"))),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center flex-shrink-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn rounded-3 px-3 py-2 w-100",
                                  class:
                                    _vm.rating === 5
                                      ? "btn-dark"
                                      : "btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.rating = 5
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "far fa-meh fa-2x d-block mb-1",
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "small" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("translate")("Not sure"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center flex-grow-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn rounded-3 px-3 py-2 w-100",
                                  class:
                                    _vm.rating === 1
                                      ? "btn-dark"
                                      : "btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.rating = 1
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "far fa-frown fa-2x d-block mb-1",
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "small" }, [
                                    _vm._v(_vm._s(_vm._f("translate")("No"))),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.rating
                        ? _c("div", { staticClass: "mt-4" }, [
                            _c(
                              "label",
                              { staticClass: "form-label small fw-semibold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")(
                                      "Why did you choose that answer?"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.review,
                                  expression: "review",
                                },
                              ],
                              staticClass: "form-control rounded-3",
                              attrs: { rows: "3" },
                              domProps: { value: _vm.review },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.review = $event.target.value
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rating
                        ? _c("div", { staticClass: "mt-3" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-dark w-100 rounded-3 fw-semibold py-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submit.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm._f("translate")("Submit")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-center bg-dark text-white rounded-circle mx-auto mb-3",
        staticStyle: {
          width: "3.5rem",
          height: "3.5rem",
          "font-size": "1.25rem",
        },
      },
      [_c("i", { staticClass: "fas fa-check" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-center bg-dark text-white rounded-circle mx-auto mb-3",
        staticStyle: {
          width: "3.5rem",
          height: "3.5rem",
          "font-size": "1.25rem",
        },
      },
      [_c("i", { staticClass: "fas fa-star" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }